// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Overlay_wrapper__3NnlE","container":"Overlay_container__2L8NN"};